import defaultClient from '@/plugins/axios/defaultClient'

export default {
  /**
   *
   * @param {
   * {
   *  "name": "상호명",
   *  "address1": "주소1",
   *  "address2": "주소2",
   *  "url": "https://example-store.com"
   * } store
   * }@returns
   */
  postStore(store) {
    return defaultClient.post('/stores', store)
  },
}
